export var AssignmentStatus;
(function (AssignmentStatus) {
    AssignmentStatus["PENDING"] = "PENDING";
    AssignmentStatus["COMPLETED"] = "COMPLETED";
    AssignmentStatus["MISSED"] = "MISSED";
    /** Offered to another member, awaiting their accept/decline. */
    AssignmentStatus["SHARED"] = "SHARED";
})(AssignmentStatus || (AssignmentStatus = {}));
